import React, { Component } from "react";
import "./button.css";
import classnames from "classnames";

export default class Button extends Component {
    static get defaultProps() {
        return {
            onClick: null,
        };
    }

    static get propTypes() {
        return {
            onClick: React.PropTypes.func,
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            isPressed: false,
        };
    }

    handleClick() {
        if (this.props.onClick !== null) {
            this.props.onClick();
        }
    }

    handleMouseDown() {
        this.setState({
            isPressed: true
        });
    }

    handleMouseUp() {
        this.setState({
            isPressed: false
        });
    }

    render () {
        return (
            <button
                onMouseDown={() => this.handleMouseDown()}
                onMouseUp={() => this.handleMouseUp()}
                className={classnames(["appointment-button", this.state.isPressed === true ? "appointment-button--pressed" : null])}
                onClick={() => this.handleClick()}>
                {this.props.children}
            </button>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/button.js
 **/